import { WSAPI } from './WSApi';
import Axios from 'axios';

const backendBaseUrl = (process.env.VUE_APP_BACKEND_URL || '').replace(/\/$/, '');
const siteAxios = Axios.create({ baseURL: '' });

function backendUrl(path: string) {
  return backendBaseUrl ? backendBaseUrl + path : path;
}

export class SiteApi extends WSAPI {
  getContact() {
    return siteAxios.get(backendUrl('/api/common/contact')).then(res => res.data);
  }

  getNciContent(params) {
    return siteAxios.get(backendUrl('/api/common/nciContent'), { params }).then(res => res.data);
  }

  submitContact(data) {
    const body = new URLSearchParams();
    Object.keys(data || {}).forEach(key => body.append(key, data[key] || ''));
    return siteAxios.post(backendUrl('/api/common/contactSubmit'), body, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(res => res.data);
  }

  private static instance: SiteApi;
  public static getInstance(): SiteApi {
    if (SiteApi.instance) {
      return SiteApi.instance;
    }
    SiteApi.instance = new SiteApi();
    return SiteApi.instance;
  }

  private constructor() {
    super();
  }
}
